import React from 'react';

import Markdown from '@components/Markdown/Markdown';

/* eslint-disable react/display-name */
export const renderMarkdown = file => () => <Markdown file={file} />;

export const propsToString = props => {
  if(!props) {return ;}

  return (
    Object.entries(props).map(([key, value]) => {
      const propType = typeof value;
      let parsedProp;

      if (value === '' || !value || key.substring(0, 2) === '__' || key !== 'bgColor') {
        parsedProp = '';

      } else if (propType === 'boolean') {
        parsedProp = `${key}=${value}`;

      } else if (propType === 'number') {
        parsedProp = `${key}={${value}}`;

      } else {
        parsedProp = `${key}="${value}"`;
      }
      return parsedProp;

    }).join(' ')
  );
};



// WEBPACK FOOTER //
// ./src/utils/index.js